
import { initializeI18n, switchLanguage } from '~/services/translationService'

export const useTranslations = () => {
  const translationsStore = useTranslationsStore()

  /**
   * Initialize translations with data
   */
  const initializeTranslations = async (data) => {
    await initializeI18n(data)
  }

  /**
   * Switch to a different language
   */
  const switchToLanguage = async (languageCode) => {
    await switchLanguage(languageCode)
  }

  /**
   * Check if translations are ready
   */
  const isReady = computed(() => translationsStore.isInitialized)

  /**
   * Check if currently loading
   */
  const isLoading = computed(() => translationsStore.isLoading)

  /**
   * Get current language
   */
  const currentLanguage = computed(() => translationsStore.currentLanguage)

  /**
   * Get available languages
   */
  const availableLanguages = computed(() => translationsStore.availableLanguages)

  /**
   * Check if a specific language is loaded
   */
  const isLanguageLoaded = (languageCode) => {
    return translationsStore.isLanguageLoaded(languageCode)
  }

  return {
    initializeTranslations,
    switchLanguage: switchToLanguage,
    isReady,
    isLoading,
    currentLanguage,
    availableLanguages,
    isLanguageLoaded
  }
}
